import type { ServiceAccountKeyJson } from '../api/types';

export function parseServiceAccountKeyJson(raw: unknown): ServiceAccountKeyJson {
  if (!raw || typeof raw !== 'object') {
    throw new Error('فرمت JSON نامعتبر است.');
  }
  const obj = raw as Record<string, unknown>;
  if (obj.type !== 'service_account') {
    throw new Error('نوع کلید باید service_account باشد.');
  }
  if (typeof obj.client_email !== 'string' || !obj.client_email.includes('@')) {
    throw new Error('فیلد client_email در JSON معتبر نیست.');
  }
  if (typeof obj.private_key !== 'string' || obj.private_key.length < 20) {
    throw new Error('فیلد private_key در JSON معتبر نیست.');
  }
  return {
    type: 'service_account',
    client_email: obj.client_email.trim(),
    private_key: obj.private_key,
    project_id:
      typeof obj.project_id === 'string' ? obj.project_id.trim() : undefined,
  };
}

export async function readServiceAccountFromFile(
  file: File,
): Promise<ServiceAccountKeyJson> {
  const text = await file.text();
  return parseServiceAccountKeyJson(JSON.parse(text));
}

export function parseServiceAccountFromText(text: string): ServiceAccountKeyJson {
  const trimmed = text.trim();
  if (!trimmed) throw new Error('متن JSON خالی است.');
  return parseServiceAccountKeyJson(JSON.parse(trimmed));
}
